<template>
  <div class="mt-4 d-flex justify-content-center align-items-center">
    <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>